/**
 * Lists errors that Sentry should avoid logging.
 */
export const ignoredErrors: RegExp[] = [/^ResizeObserver.*/g];

/**
 * Lists errors that cannot be fixed by a user refreshing the page.
 */
export const unfixableErrors: RegExp[] = [/^TypeError.*/g];
